import { ServiceTypeEnum } from '@sr-sdks/api-sdk-axios';
import { ScopedStatementsPage } from './ScopedStatementsPage';

export const DISBURSEMENT_SERVICE_TYPES = [
  ServiceTypeEnum.CollectionAccount,
  ServiceTypeEnum.Disbursements,
];

export const Disbursements = () => (
  <ScopedStatementsPage
    title="Disbursements"
    csvFileLabel="disbursements"
    paginationKey="disbursementsStatementsTablePage"
    serviceTypes={DISBURSEMENT_SERVICE_TYPES}
  />
);
